/*<-----------------imports------------------------->*/
import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonOne from "../../general/button/button.component";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { textAlign } from "@mui/system";
/*<-----------------imports------------------------->*/

/* style for modal */
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const button = {
  textAlign: "center",
  marginTop: 25,
};
export const ModalLink = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button style={{ color: "#051d73" }} onClick={handleOpen}>
        View more
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <b>Description</b>: {props.desc}
          </Typography>
          <div style={button}>
            <a href={props.link}>
              <ButtonOne>Register</ButtonOne>
            </a>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
